import "@/shared/SFAnalytics";
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import {Plugin} from 'vue-fragment';
import {mapActions} from "vuex";
import Toasted from 'vue-toasted';
import {Modal, Dialog, Upload, Dropdown, Carousel, Collapse, Tooltip, Tabs, Notification} from 'buefy'
import {
    formatDollars,
    formatDollarsNoZeros,
    formatDollarsNoZerosShaded,
    formatMillionsDollars
} from "./shared/moneyUtils";
import {config} from "@/config/config";

new Vue({
    router,
    store,
    data() {
        return {
            loading: true // init state is true because we want to block page rre
        }
    },
    async created() {
        document.dispatchEvent(new Event('render-event'))
        // let isLoggedIn = await this.updateUserData();
    },
    mounted() {
        setTimeout(()=>{
            document.dispatchEvent(new Event('render-event'))
        },100)
    },
    methods: {
        ...mapActions([
            'updateUserData'
        ]),
    },
    render: h => h(App)
}).$mount('#app')


Vue.config.productionTip = false
Vue.use(Modal);
Vue.use(Tooltip);
Vue.use(Dialog);
Vue.use(Upload);
Vue.use(Dropdown);
Vue.use(Carousel);
Vue.use(Collapse);
Vue.use(Tabs);
Vue.use(Notification);
Vue.use(require('vue-moment'));
Vue.use(Plugin);
Vue.use({
    install: function (Vue, options) {
        console.log('init')
    }
});

Vue.use(Toasted)


Vue.filter('formatDollars', formatDollars)
Vue.filter('formatDollarsNoZeros', formatDollarsNoZeros)
Vue.filter('formatDollarsNoZerosShaded', formatDollarsNoZerosShaded)
Vue.filter('formatMillionsDollars', formatMillionsDollars)

window.clearInterval(window.secInterval)
window.secInterval = setInterval(() => {
    $('.locked').each(function () {
        // console.log($(this).css('filter'))
        if ($(this).css('filter') !== 'blur(5px)') {
            $(this).css('filter', 'blur(5px)')
        }
    });
}, 2000);
//     import echarts from 'echarts';
//
// window.onresize = function () {
//     $(".falcon-chart").each(function () {
//         var id = $(this).attr('_echarts_instance_');
//         echarts.getInstanceById(id).resize();
//     });
// };

window.cflog = console.log;

// run integrations
setTimeout(() => {
    for (let integration of config('INTEGRATIONS')) {
        integration();
    }
}, 100)

window.onload = function(){

}
